<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="60px" inline>
        <el-form-item label="品牌">
          <el-input
            v-model="queryForm.brandName"
            style="width: 200px"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="品类">
          <el-input
            v-model="queryForm.categoryName"
            style="width: 200px"
            size="small"
          ></el-input>
        </el-form-item>
        <el-button @click="search" type="primary"  size="small" style="margin-top: 4px;margin-left: 10px;">查询</el-button>
        <el-button @click="reset"  size="small">重置</el-button>
         <el-button type="primary" @click="addNew"  size="small">新增品牌品类组</el-button>
      </el-form>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="groupId" width="80"> </el-table-column>
      <!-- <el-table-column prop="groupName" width="100"> </el-table-column> -->
      <el-table-column label="品牌">
        <template slot-scope="scope">
          <div>
            <el-input
              v-model="scope.row.brandName"
              @keyup.enter.native="handleChange(scope.row, 1)"
              style="width: 200px"
              size="mini"
            ></el-input>
          </div>
          <div style="padding: 8px 0 0 0">
            <el-tag
              v-for="tag in scope.row.brandMappingConfigList"
              :key="tag.apiBrandBlockMappingConfigId"
              @close="handleClose(tag, scope.row)"
              closable
              style="margin-bottom: 8px; margin-right: 10px"
              size="small"
            >
              {{ tag.brandMappingConfigName }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="品类">
        <template slot-scope="scope">
          <div>
            <el-input
              v-model="scope.row.categoryName"
              @keyup.enter.native="handleChange(scope.row, 2)"
              style="width: 200px"
              size="mini"
            ></el-input>
          </div>
          <div style="padding: 8px 0 0 0">
            <el-tag
              v-for="tag in scope.row.categoryMappingConfigList"
              :key="tag.apiBrandBlockMappingConfigId"
              @close="handleClose(tag, scope.row)"
              closable
              style="margin-bottom: 8px; margin-right: 10px"
              size="small"
            >
              {{ tag.categoryMappingConfigName }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="deleteGroup(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { startOfDay, endOfDay, addDays } from "date-fns";
import utils from "@/utils/util";
import {
  getBlackList,
  addBlack,
  deleteBlack,
  deleteGroupBlack,
  getCategory,
} from "../../../api/mapping_cn";
import { getBrandList } from "../../seller/api_cn";
import BrandSelect from "../../shared/brandSelect.vue";

export default {
  components: { BrandSelect },
  data() {
    return {
      queryForm: {
        brandName: null,
        categoryName: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [
        {
          brandName: "",
          categoryName: "",
          groupId: 1,
          groupName: "hh",
        },
      ],
      total: 0,
      brandList: [],
      categoryList: [],
    };
  },
  mounted() {
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.brandId,
      }));
      this.brandList.unshift({
        label: "全部品牌",
        value: -1,
      });
    });
    getCategory().then((res) => {
      if (res.data && res.data.data) {
        this.categoryList = Object.freeze(this.gatherCategory(res.data.data));
      }
    });
    this.getTableData();
  },
  methods: {
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map((item) => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId,
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    addNew() {
      this.tableData.unshift({
        brandMappingConfigList: [],
        categoryMappingConfigList: [],
        groupId: null,
        groupName: null,
      });
    },
    addBlack(params) {
      addBlack(params).then((res) => {
        if (res.data.success) {
          this.$message.success("新增成功");
          this.getTableData();
        } else {
          this.$message.error(res.data.message || "操作失败");
        }
      });
    },
    handleClose(tag, row) {
      deleteBlack({
        apiBrandBlockMappingConfigId: tag.apiBrandBlockMappingConfigId,
        groupId: row.groupId,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getTableData();
        } else {
          this.$message.error(res.data.message || "操作失败");
        }
      });
    },
    deleteGroup(row) {
      deleteGroupBlack({
        groupId: row.groupId,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getTableData();
        } else {
          this.$message.error(res.data.message || "操作失败");
        }
      });
    },
    handleChange(row, type) {
      console.log(row);
      if ((type == 1 && !row.brandName) || (type == 2 && !row.categoryName)) {
        return;
      }
      let params = {
        brandName: null,
        categoryName: null,
        groupId: row.groupId,
        groupName: row.groupName,
      };
      if (type == 1 && row.brandName) {
        params.brandName = row.brandName;
      }
      if (type == 2 && row.categoryName) {
        params.categoryName = row.categoryName;
      }
      this.addBlack(params);
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm = {
        brandName: null,
        categoryName: null,
        pageNo: 1,
        pageSize: 25,
      };
      this.getTableData();
    },
    setDefaultDate() {
      this.daterange = [];
      const startTime = startOfDay(addDays(new Date(), -30)).getTime();
      const endTime = endOfDay(new Date()).getTime();
      this.daterange = [startTime, endTime];
    },
    onDateBlur() {
      this.firstDate = null;
    },
    getTableData() {
      getBlackList({
        ...this.queryForm,
      }).then((res) => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = (res.data.data.list || []).map((item) => ({
            ...item,
            brandName: null,
            categoryName: null,
          }));
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.red {
  color: red;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #dcdfe6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409eff;
  }
}
.vendor-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/deep/.el-table__cell{
  padding: 8px 0 0 0
}
</style>
